module.exports = __webpack_public_path__ + "img/diploma2.a13f554c.jpg";